// sides
export const LEFT = 'left';
export const RIGHT = 'right';
export const FRONT = 'front';
export const BACK = 'back';
